import React from 'react'
import { FormObjectType, JoinFormType } from 'src/types/react-hook-form'
import { useFormContext } from 'react-hook-form'
import { FormInput } from 'src/components/Input/styled'
import { RuleSet } from 'styled-components'
import handleAutoInputGuard from 'src/service/utils/handleAutoInputGuard'

interface FormInputProps {
  registerAttribute: Record<keyof JoinFormType, Partial<FormObjectType>>
  placeholder?: string
  keyDownFunc: () => void
  style?: RuleSet<object>
}

const handleOnKeyDown = (event: React.KeyboardEvent<HTMLInputElement>, callbackFn: () => void) =>
  event.key === 'Enter' && callbackFn()

const handleInputFocus = (element: HTMLInputElement | null) => {
  document
    .getElementById('middle_Image')
    ?.scrollIntoView({ inline: 'start', block: 'start', behavior: 'auto' })
}

const PNumberInput = ({
  registerAttribute,
  placeholder = '휴대폰 번호 입력',
  keyDownFunc,
  style,
}: FormInputProps) => {
  const { register, getValues } = useFormContext<JoinFormType>()

  return (
    <FormInput
      {...register('PNumber', registerAttribute.PNumber.register_options)}
      id="ipt_phonenumber"
      className="ipt_phonenumber"
      placeholder={placeholder}
      type={registerAttribute.PNumber.type}
      inputMode={registerAttribute.PNumber.register_options?.inputMode}
      onKeyDown={(event) => handleOnKeyDown(event, keyDownFunc)}
      onFocus={(element) => handleInputFocus(element.target)}
      disabled={getValues('TranID') !== ''}
      $style={style}
    />
  )
}

const ApprovalNumberInput = ({
  registerAttribute,
  placeholder = '인증번호 입력',
  keyDownFunc,
  style,
}: FormInputProps) => {
  const { register } = useFormContext<JoinFormType>()

  return (
    <FormInput
      {...register('ApprovalNumber', registerAttribute.ApprovalNumber.register_options)}
      id="ipt_smscode"
      className="ipt_smscode"
      placeholder={placeholder}
      autoComplete={'one-time-code'}
      type={registerAttribute.ApprovalNumber.type}
      inputMode={registerAttribute.ApprovalNumber.register_options?.inputMode}
      onFocus={(element) => handleInputFocus(element.target)}
      onKeyDown={(event) => handleAutoInputGuard(event, keyDownFunc)}
      $style={style}
    />
  )
}

export const Input = {
  PNumber: PNumberInput,
  ApprovalNumber: ApprovalNumberInput,
}
